import ProEncInputEdit from "@/components/pro-common/pro-enc/pro-enc-input-edit.vue";
import ProEncInputShow from "@/components/pro-common/pro-enc/pro-enc-input-show.vue";
import { getEncText } from "@/service/user.js";
import { decode } from "@/libs/rsa.js";
export default {
  name: "pro-enc-input",
  components: {
    ProEncInputEdit,
    ProEncInputShow
  },
  props: {
    disabled: {
      type: Boolean,
      default() {
        return false;
      }
    },
    value: {
      type: String,
      default() {
        return "";
      }
    },
    mode: {
      type: String,
      default() {
        return "UNIT_USER_MOBILE";
      }
    },
    params: {
      type: Object,
      default() {
        return {
          userId: ""
        };
      }
    }
  },
  data() {
    return {
      loading: false,
      decodeValue: "",
      // 原始值
      encodeValue: "" // 编码值
    };
  },
  mounted() {
    this.encodeValue = this.value;
  },
  watch: {
    "params.userId": {
      immediate: true,
      handler(val) {
        if (val) {
          this.onDecrypt();
        }
      }
    }
  },
  methods: {
    onChange(val) {
      this.$emit("input", val);
      this.$emit("onChange");
    },
    async onDecrypt() {
      let params = {
        mode: this.mode,
        ...this.params
      };
      this.loading = true;
      const {
        data
      } = await getEncText(params);
      this.loading = false;
      if (data && data.result === 0) {
        this.decodeValue = decode(data.retVal);
        this.$emit("input", this.decodeValue);
      }
    }
  }
};